(function ($) {
    $(document).ready(function () {
        galleryGrid();

    });

    function galleryGrid() {
        var wrapper = $('.gallery_section.grid');
        wrapper.each(function () {
            var current = $(this);
            var wrap = current.find('.elements_to_filter');
            wrapper.trigger('builder_gallery_init');
            if (wrap.length > 0) {
                wrap.trigger('builder_gallery_ready');
                var filter_tabs = current.find('.filters_wrap .filter-tabs'),
                    filter_tab_list = filter_tabs.find('.filter-tab').children(),
                    select = current.find('.filters_select select');

                if(filter_tabs.length > 0){
                    if(filter_tab_list.length > 0){
                        filter_tab_list.each(function(){
                            var single_tab = $(this).find('.single-filter'),
                                siblings = $(this).siblings().find('.single-filter');
                            single_tab.on('click', function(){
                                var current_filter = $(this).data('filter');
                                siblings.removeClass('current');
                                $(this).addClass('current');
                                if(current_filter === 'filter_all'){
                                    wrap.find('.thumb_wrap').show();
                                } else {
                                    wrap.find('.thumb_wrap').hide();
                                    wrap.find('.thumb_wrap' + current_filter).show();
                                }
                            });
                        });
                    }
                }

                select.change(function () {
                    var $this = $(this);

                    $this.trigger('builder_gallery_select_click');

                    var selector = $this.val(),
                        newRel = selector.replace('.', '');
                    wrap.find('.thumb_wrap' + selector).find('.thumb').attr("data-fancybox", newRel + '_thumb');
                    wrap.find('.thumb_wrap' + selector).find('.description').attr("data-fancybox", newRel + '_desc');
                    wrap.find('.thumb_wrap').hide();
                    wrap.find('.thumb_wrap' + selector).show();
                });

            }
        });
    }
}(jQuery) );
